import { ArrowRightIcon } from '@heroicons/react/outline';
import * as React from 'react';

import { Button } from '@/components/Elements';

export type GoToProps = {
  textLabel: string;
  onClickGoTo?: any;
  textLink: string;
  url: string;
};

export const GoTo = ({ textLabel, onClickGoTo, url, textLink }: GoToProps) => {
  const goToIcon = <ArrowRightIcon className="h-5 w-5 text-md-purple" aria-hidden="true" />;
  const onClick = (url: any, onClickButton: any) => {
    onClickButton && onClickButton();
    window.location = url;
  };
  return (
    <div className="mt-8 mb-8 md__goto m-auto overflow">
      <div className="md__goto__grid">
        <p className="mb-2 text-center font-bold text-4xl md__goto__title">{textLabel}</p>
        <div className="flex justify-center md__goto__action">
          <div>
            <Button
              variant="rounded"
              type="button"
              endIcon={goToIcon}
              onClick={() => onClick(url, onClickGoTo)}
              title={textLink}
              className="text-md-mediumGray hover:text-md-mediumGray hover:no-underline"
            >
              {textLink}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
